import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'objectArrayContainsValue',
    standalone: true
})
export class ObjectArrayContainsValuePipe implements PipeTransform {
  transform(
    value: Record<string, unknown>[] | undefined,
    attributeName: string,
    attributeValue: unknown
  ): boolean {
    if(value === undefined) return false;
    if(value.length <= 0) return false;
    return value.findIndex(item => typeof item === 'object' && attributeName in item && (item[attributeName] as unknown) === attributeValue) !== -1;
  }
}
